import { Component } from "@angular/core";

@Component({
  selector: "icon-ajuste-pension-pgu",
  templateUrl: "./ajuste-pension-pgu.svg",
  standalone: true,
})
export class AjustePensionPguComponent {}